import api from 'Plugins/api'
import {localget, localset} from 'Utils/storage.js'
import {isAndroid, isIOS} from 'CommonUtils/plus'


/**
 * 系统级参数
 * 11605013 是否默认出发城市
 * @param {String} paramNo 参数编号
 */
export const getSysParameter = (paramNo) => {
  return new Promise((resolve) => {
    api['common/getSysParameter']({
      paramNo: paramNo
    }).then(res => {
      var cache = res.data || {}
      resolve(cache)
    })
  })
}

/**
 * 系统级参数
 * 11605013 是否默认出发城市
 * 
 * @param {String} paramNo 参数编号
 */
export const getSysParameterallow = (paramNo,companySuper) => {
  console.log('paramNo',paramNo,companySuper)
  return new Promise((resolve) => {
    api['common/getSysParameterallow']({
      paramNo: paramNo,
      companySuper:companySuper
    }).then(res => {
      console.log('resresres',res.data)
      var cache = res.data || {}
      resolve(cache)
    })
  })
}



/**
 * 企业级参数 可请求多个
 * 页面参数控制
 * 20021 - 使用公司账户支付时是否需要输入密码 默认否
 * @param {String} paramNos 参数编号 多个以逗号分隔
 */
export const queryParameter = (paramNos) => {
  return new Promise((resolve) => {
    api['common/queryParameter']({
      paramNos: paramNos
    }).then(res => {
      var cache = res.data || {}
      resolve(cache.parameterResponses)
    })
  })
}

/**
 * 新版 企业级参数 可请求单个
 * 11605003 是否默认出发城市
 * @param {String} paramNo 参数编号
 */

export const queryVipParameter = (paramNo) => {
  return new Promise((resolve) => {
    api['common/queryVipParameter']({
      paramNo: paramNo
    }).then(res => {
      var cache = res.data || {}
      resolve(cache)
    })
  })
}
/**
 * 查询国籍列表
 */
export const queryNation = () => {
  let data = localget('_azCountryForPx')
  if (!data) {
    api['common/getFindNationList']().then(res => {
      localset('_azCountryForPx', res.data.list)
      return res.data.list
    })
  } else {
    return data
  }
}

/**
 * 查询省份城市列表
 */
export const getProvince = async () => {
  let data = localget('provinceArray')
  if (!data) {
    let {data} = await api['city/proCity']()
    const PROVINCE = data.province['00002'] // 省份
    const CITY = data.city // 城市

    let province_list = {},
      city_list = {}

    PROVINCE.forEach(province => {
      province_list[province.id] = province.cName

      if (CITY[province.id]) {
        CITY[province.id].forEach(city => {
          city_list[city.id] = city.cityName
        })
      }
    })
    let AreaJson = {
      province_list,
      city_list
    }
    localset('provinceArray', data)
    return data
  } else {
    return data
  }
}

/**
 * 推送 保存 clientid
 */
export const saveAppTsInfo = (clientid) => {
  clientid = clientid || localget('clientid') || ''
  if (clientid) {
    api['app/saveAppTsInfo']({
      tsCid: clientid,
      tsDevice: isAndroid() ? 1 : (isIOS() ? 2 : ''),//1 安卓 2 ios
    }).then(() => {
      console.log('保存成功！')
    }).catch(() => {
      console.log('保存失败！')
    })
  } else {
    console.log('clientid is null')
  }
}

//获取单个控制参数
export const getParameter = (paramNo) => {
  return new Promise((resolve) => {
    api['common/getParameter']({
      paramNo: paramNo
    }).then(res => {
      var cache = res.data || {}
      resolve(cache)
    })
  })
}

//获取单个控制参数
export const getParListByCodes = (paramNo) => {
  return new Promise((resolve) => {
    api['common/getParListByCodes']({
      codes: paramNo
    }).then(res => {
      var cache = res.data || {}
      resolve(cache)
    })
  })
}


export const getPoundageForRefundChange = (paramNo) => {
  console.log("paramNoparamNoparamNo",paramNo)
  return new Promise((resolve) => {
    api['tkIntQuery/getPoundageForRefundChange'](
      paramNo
    ).then(res => {
      var cache = res.data || {}
      resolve(cache)
    })
  })
}

